<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-info mb-1">
                <i class="fa-solid fa-user"></i>
                ユーザー管理
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3">
                <simple-search v-model="keyword" 
                    @find="find()"
                    @clear="clear()"
                    placeholder="名前またはアカウントで検索"></simple-search>
            </div>
            <!-- AD同期ボタン -->
            <div class="mb-3 d-flex justify-content-end">
                <button class="btn btn-outline-success me-2" :disabled="syncing" @click="syncAD">
                    <span v-if="syncing">
                        <span class="spinner-border spinner-border-sm"></span>
                        同期中...
                    </span>
                    <span v-else>
                        <span class="fa-solid fa-arrows-rotate"></span>
                        AD同期
                    </span>
                </button>
                <button class="btn btn-outline-primary" @click="editUser()">
                    <span class="fa-solid fa-plus"></span>
                    新規追加
                </button>
            </div>
            <!-- ページネーション -->
            <div class="sticky mb-3">
                <pagination v-bind="users" @goto="goto" :showTotal="true"></pagination>
            </div>
            <div v-for="user in users.data" :key="user.id" class="card mb-2">
                <div class="card-body d-flex justify-content-between align-items-center" :class="{disabled: user.locked_at}">
                    <div class="d-flex jutify-content-start">
                        <div class="d-flex align-items-center me-2">
                            <button class="btn btn-outline-secondary me-2" @click="editUser(user.id)">
                                <span class="fa-solid fa-pencil"></span>
                            </button>
                        </div>
                        <div class="d-flex align-items-center me-2">
                            <button class="btn btn-outline-warning me-2" @click="inpersonate(user.id)">
                                <i class="fa-solid fa-user-secret"></i>
                                なりすまし
                            </button>
                        </div>
                        <div>
                            <div class="fs-5 fw-bold flex-grow-1 d-flex align-items-center">
                                <div class="badge bg-warning me-2" v-if="user.locked_at">
                                    <i class="fa-solid fa-lock"></i>
                                </div>
                                <div class="badge bg-danger me-2" v-if="user.is_root">管理者</div>
                                <div class="me-2">
                                    {{ user.name }}
                                    <span class="badge" :class="{
                                        'bg-primary': user.menus_count > 0,
                                        'bg-secondary': !user.menus_count,
                                    }" v-if="!user.is_root">
                                        {{ user.menus_count }}
                                    </span>
                                </div>
                            </div>
                            <div class="small text-muted d-flex justify-content-start">
                                <div class="me-2 fw-bold">
                                    {{ user.section }}
                                </div>
                                <div class="me-2">
                                    {{ user.email }}
                                    <span v-if="user.gmail">
                                        <i class="fa-brands fa-google"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-danger" @click="destroy(user)">
                            <span class="fa-solid fa-xmark"></span> 抹消
                        </button>
                    </div>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <users-editor
                :user_id="user_id"
                @saved="reload"
                @close="closeModal"
            />
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<script>
import UsersEditor from './usersEditor.vue'
import simpleSearch from "components/simpleSearch.vue";
export default {
    components: {
        UsersEditor,
        simpleSearch,
    },
    data() {
        return {
            users: [],
            modals: [],
            keyword: '',
            user_id: null,
            syncing: false,
            page: 1,
            isLoading: false,
        }
    },
    methods: {
        find() {
            this.page = 1;
            setTimeout(() => {
                this.reload();
            });
        },
        clear() {
            this.keyword = '';
            this.find();
        },
        goto(page) {
            this.page = page;
            setTimeout(() => {
                this.reload();
            });
        },
        reload() {
            this.isLoading = true;
            axios.get('/api/admin/users', {
                params: {
                    keyword: this.keyword,
                    page: this.page,
                }
            }).then(res => {
                this.users = res.data;
                this.isLoading = false;
            }).catch(err => {
                Alert.err(err);
                this.isLoading = false;
            });
        },
        editUser(id = null) {
            this.user_id = id;
            setTimeout(() => {
                this.modals['user-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        destroy(user) {
            swal({
                title: "ユーザー抹消",
                text: "このユーザーを抹消します。よろしいですか？",
                icon: "warning",
                buttons: ["キャンセル", "抹消"],
                dangerMode: true,
            }).then(confirm => {
                if (confirm) {
                    axios.delete(`/api/admin/users/${user.id}`).then(() => {
                        Alert.msg("ユーザーを抹消しました");
                        this.reload();
                    }).catch(err => {Alert.err(err)});
                }
            });
        },
        syncAD() {
            this.syncing = true;
            axios.post('/api/admin/users/sync-ad').then(() => {
                    Alert.msg('AD同期が完了しました');
                    this.reload();
                }).catch(() => {
                    Alert.msg('AD同期に失敗しました');
                }).finally(() => {
                    this.syncing = false;
                });
        },
        inpersonate(id) {
            axios.post('/api/admin/user/inpersonate', {id: id}).then(res => {
                location.href = '/';
            }).catch(err => {Alert.err(err)});
        }
    },
    mounted() {
        this.modals['user-editor'] = new bootstrap.Modal(document.getElementById('user-editor'));
        this.reload();
    }
}
</script>
